import { createReducer } from '@reduxjs/toolkit'

import { DATES } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import {
    defaultResourcePage,
    defaultDspResourcePageTabs,
    defaultDspResourcePageWidgets,
} from 'reducers/ui/defaults'

const defaultState = {
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [],
        displayState: {},
    },
    ...defaultResourcePage,
    tabs: defaultDspResourcePageTabs,
    widgets: defaultDspResourcePageWidgets('dspAdvertiserPage'),
}

export default createReducer(defaultState, () => {})
